<template>
  <BaseModal
    small
    :heading="$t('marketing.email.variables-modal.heading')"
    @close="$emit('close')"
  >
    <Flex direction="column">
      <BaseText>{{ $t('marketing.email.variables-modal.info') }}</BaseText>
      <BaseText bold>
        {{ $t('marketing.email.variables-modal.what_you_can_use') }}
      </BaseText>
      <BaseAccordion
        v-model="activeAccordionItems"
        :titles="accordionTitles"
      >
        <template #1>
          <Variables :variables="customerVariables" />
        </template>
        <template #2>
          <Variables :variables="companyVariables" />
        </template>
      </BaseAccordion>
    </Flex>
    <template #footer>
      <BaseButton @click="$emit('close')">
        {{ $t('global.actions.close') }}
      </BaseButton>
    </template>
  </BaseModal>
</template>

<script
  setup
  lang="ts"
>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import Variables from '@/modules/_shared/Variables.vue';
import { useCompanyStore } from '@/stores/company';

defineEmits(['close']);

const { t } = useI18n();
const { multiLocation } = useCompanyStore();

const activeAccordionItems = ref<string[]>(['1']);
const accordionTitles = [
  t('admin.invoices.content.customer_variables_title'),
  t('admin.invoices.content.company_variables_title'),
];

const customerVariables = [
  'id',
  'salutation',
  'salutation_short',
  'first_name',
  'last_name',
  'birthday',
  'address',
  'phone',
  'postalcode',
  'city',
  'custom1',
  'custom2',
  'custom3',
  'custom4',
  'custom5',
  'custom6',
  'custom7',
  'custom8',
  'custom9',
  'custom10',
];

const companyVariables = [
  'company_name',
  'company_address',
  'company_phone',
  'company_email',
];

if (multiLocation) {
  companyVariables.push('company_bank_account');
}
</script>
